import api from "../APIIntercepter";

async function loginAPI(params) {
  const res = await api.post("user/login", params);
  return res.data;
}

async function registerAPI(params) {
  const res = await api.post("user/student/register", params);
  return res.data;
}

async function generateOTPAPI(params) {
  const res = await api.post("otp/generateOTP", params);
  return res.data;
}

async function verifyOTPAPI(params) {
  const res = await api.post("otp/verifyOTP", params);
  return res.data;
}

async function resetPasswordAPI(params) {
  const res = await api.post("user/forgotPassword", params);
  return res.data;
}

export { loginAPI, registerAPI, generateOTPAPI, verifyOTPAPI, resetPasswordAPI };
